import React from 'react';
import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Icon,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { LabelPrintCommand, LabelPrintTask } from '../../../../models/labels';

interface IPrintLabelsDialogProps {
  opened: boolean;
  setDialog: (value: boolean) => void;
  selLabel: LabelPrintTask;
  setSelLabel: (l: LabelPrintTask) => void;
  labelPrintCommand: LabelPrintCommand;
  labelTask: any;
  onConfirm: () => void;
  onClose: () => void;
  onReject: () => void;
}

const PrintLabelsDialog: React.FC<any> = (props: IPrintLabelsDialogProps) => {
  const { opened, setDialog, selLabel, onConfirm, onClose, onReject } = props;

  const { t } = useTranslation();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  const handleDialogClose = () => {
    onClose();
    setDialog(false); // Use the prop.
  };

  const isDone = selLabel?.printedCount < selLabel?.requestedCount;

  const title = t('f-label-print-prog-title');
  const btnText = t('f-yes');

  return (
    <Dialog fullWidth={true} maxWidth="sm" open={opened} fullScreen={fullScreen} onClose={handleDialogClose}>
      {fullScreen && (
        <AppBar>
          <Toolbar>
            <Typography variant="h6">{title}</Typography>
          </Toolbar>
        </AppBar>
      )}

      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <Grid container>
          <Grid item>
            <Typography variant="subtitle1">
              {t('f-label-printing-prog', {
                printedCount: selLabel?.printedCount,
                requestedCount: selLabel?.requestedCount
              })}
            </Typography>
            {isDone && <Typography variant="subtitle2">{t('f-confirm-printed-label')}</Typography>}
          </Grid>
        </Grid>
      </DialogContent>

      {isDone ? (
        <DialogActions>
          <Button onClick={() => onReject()} startIcon={<Icon>close</Icon>} color="primary">
            {t('f-no')}
          </Button>

          <Button startIcon={<Icon>done</Icon>} color="primary" onClick={() => onConfirm()}>
            {btnText}
          </Button>
        </DialogActions>
      ) : (
        <DialogActions>
          <Button onClick={() => handleDialogClose()} startIcon={<Icon>close</Icon>} color="primary">
            {t('m-task-status-done')}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default PrintLabelsDialog;
